import { ThreadInteractionContext } from "features/Thread/context/ThreadInteractionContext";
import { useContext } from "react";
import useThread from "../../../hooks/useThread";

/**
 * `useCurrentThread` is a custom React hook for fetching a thread
 * provided it is called in the ThreadInteractionProvider context.
 */
export function useCurrentThread() {
  const threadContext = useContext(ThreadInteractionContext);

  const useThreadResult = useThread(threadContext?.threadId);

  // If we have a thread context, use that threadId
  if (threadContext) {
    return {
      ...useThreadResult,
      interactionId: threadContext.interactionId,
    };
  }
}
